<ol class="breadcrumb">
  <li class="breadcrumb-item"><a routerLink="/locations">Locations</a></li>
  <li class="breadcrumb-item active">{{locationCollection.name}}</li>
</ol>

<div class="btn-group pull-right action-dropdown" dropdown>
  <button dropdownToggle class="btn btn-link dropdown-toggle">
    <span>Actions</span>
    <app-icon icon="more-vertical" iconClass="action-icon"></app-icon>
  </button>
  <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu">
    <li><a class="dropdown-item blue-text" (click)="editLocationCollection()">Edit</a></li>
    <li><a class="dropdown-item blue-text" (click)="deleteLocationCollection()">Delete</a></li>
  </ul>
</div>

<h3>
  {{locationCollection.name}}
</h3>

<div class="row">
  <div class="col-xs-12">

    <p-table
      [value]="locations"
      selectionMode="single"
      [(selection)]="selectedLocation"
      (onRowSelect)="onRowSelect($event)"
      (onRowUnselect)="null"
      [paginator]="true"
      [rows]="10"
      stateStorage="session"
      stateKey="state-session-locations"
      >
      <ng-template pTemplate="header">
        <tr>
          @for (key of keys; track key) {
            <th pSortableColumn="{{ key }}" [style.width]="tableConfig.columns[key].width">
              {{ tableConfig.columns[key].title }} <p-sortIcon field="{{ key }}"></p-sortIcon>
            </th>
          }
        </tr>
        <tr>
          @for (key of keys; track key) {
            <th style="width:15%">
              <p-columnFilter
                type="text"
                field="{{key}}"
                placeholder="{{tableConfig.columns[key].title}}"
                ariaLabel="Filter {{tableConfig.columns[key].title}}"
                />
            </th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-locations>
        <tr [pSelectableRow]="locations">
          @for (key of keys; track key) {
            <td>{{ locations[key] }}</td>
          }
        </tr>
      </ng-template>
    </p-table>
    <button class="btn btn-primary" (click)="addLocation($event)">
      Add Location
    </button>
  </div>
</div>
